<script>
  import { onMount } from 'svelte'
  import { Row, Col, Card, CardBody } from 'sveltestrap'
  import { user } from '../../services/user.js'

  let roleName
  let totalNames
  let thumbnailUrl

  // Usamos new_profile para obtener el nombre y apellido
  $: if ($user && $user.new_profile) {
    totalNames = $user.new_profile.Name + ' ' + $user.new_profile.Lastname
  } else {
    totalNames = 'Nombre no disponible'
  }

  // Obtenemos el rol a partir del objeto user.role
  $: if ($user && $user.role) {
    roleName = $user.role.name
  } else {
    roleName = 'Rol no disponible'
  }

  // Obtenemos la imagen del avatar; si existe un thumbnail lo usamos, de lo contrario el URL principal
  $: if (
    $user &&
    $user.new_profile &&
    $user.new_profile.avatar &&
    $user.new_profile.avatar.length > 0
  ) {
    if (
      $user.new_profile.avatar[0].formats &&
      $user.new_profile.avatar[0].formats.thumbnail
    ) {
      thumbnailUrl = $user.new_profile.avatar[0].formats.thumbnail.url
    } else {
      thumbnailUrl = $user.new_profile.avatar[0].url
    }
  } else {
    thumbnailUrl = 'URL-de-imagen-por-defecto.png' // Cambia este valor por tu imagen por defecto o mensaje
  }

  let data = ''
  async function getData() {
    let location = 'es-CL'
    location = await localStorage.getItem('LANGUAGE')
    if (location === 'es') {
      location = 'es-CL'
    }
    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
    }
    fetch(
      `https://api.rastros.cl/api/home-screen?populate=%2A&locale=${location}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        data = result.data
      })
      .catch((error) => console.log('error al contactar al servicio: ', error))
  }

  onMount(async () => {
    await getData()
  })
</script>

<Card style="height: 93%;">
  <div class="bg-primary bg-soft">
    <Row>
      <Col xs="7">
        <div class="text-primary p-3">
          <h5 class="text-primary">{data.welcomeText}</h5>
          <p>{data.systemNameLabel}</p>
        </div>
      </Col>
      <Col xs="5" class="align-self-end">
        {#if data && data.logo && data.logo.url}
          <img src={data.logo.url} alt="Logo del sistema" class="img-fluid" />
        {/if}
      </Col>
    </Row>
  </div>
  <CardBody>
    <Row>
      <Col sm="12">
        <div class="avatar-md profile-user-wid mb-4">
          <img
            src={thumbnailUrl}
            alt="Avatar"
            class="img-thumbnail rounded-circle"
          />
        </div>
        <h5 class="font-size-15 text-truncate">{totalNames}</h5>
        <p class="text-muted mb-0 text-truncate">{roleName}</p>
      </Col>
    </Row>
  </CardBody>
</Card>

<style>
  /* Puedes ajustar los estilos según tu necesidad */
  .avatar-md {
    width: 100px;
    height: 100px;
    overflow: hidden;
    margin: 0 auto;
  }
  .profile-user-wid img {
    width: 100%;
    height: auto;
  }
</style>
